import * as React from 'react';
import {
    Wrapper,
    Container,
    Summary,
    Count,
    Ubigeo,
    Result,
    Item,
    Text,
    Name
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';

interface Props {
  list?: any;
  ubigeo?: string;
}

export const SearchResult: React.FC<Props> = ({ list, ubigeo }) => (
  <Wrapper>
    <Container>
      <Summary>
        <Count>{list.length}</Count>
        &nbsp;agencias publicitarias
        {ubigeo && <Ubigeo>&nbsp;en <span>{ubigeo}</span></Ubigeo>}
      </Summary>
      <Result>
        <ul>
          {
            list && list.length >= 1 &&
              list.map((agency, index) =>
                <Item key={index}>
                  <Name>{agency.data.name}</Name>
                  <Text>
                    <Icon data-name="icon-map" width="12" height="12" fill={COLORS.GRAY_TEXT} />
                    <p>{agency.data.address}</p>
                  </Text>
                </Item>
              )
          }
        </ul>
      </Result>
    </Container>
  </Wrapper>
);
